const TickIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
    >
      <circle cx="4.70825" cy="3.75" r="3.75" fill="#B6E9D1" />
      <path
        d="M2.83325 4.10156L3.85598 5.15625L6.58325 2.34375"
        fill="#B6E9D1"
      />
      <path
        d="M2.83325 4.10156L3.85598 5.15625L6.58325 2.34375"
        stroke="#12B76A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default TickIcon;
